/**
 * Sentinel values for a campaign's preferredAreaCode request field.
 * 'Toll-free' is part of the external API contract and the portal UI:
 * it means "no preferred local area code" and is normalized to null
 * before persistence.
 */
export enum PreferredAreaCodeEnum {
  TOLL_FREE = 'Toll-free'
}
